import { UseFormReturn } from 'react-hook-form'
import useFilials from '@hooks/useFilials'
import { createInitFilter } from '@utils/filters'
import { Company } from '@models/company'
import useHasJobs from './useHasJobs'
import { JobData } from './useJobDataForFields'

const useFilialsJobData = (
  methods: UseFormReturn,
  companiesJobData: JobData | null,
  companyFieldName = 'company'
): JobData | null => {
  const { watch } = methods
  const company: Company | undefined = watch(companyFieldName)

  const { hasFilial, hasCompany } = useHasJobs()

  const filialsResponse = useFilials({
    skip: hasCompany && !company,
    ...(company?.id
      ? { initFilters: createInitFilter('company', company?.id) }
      : {}),
  })
  const { items = [], length = 0 } = filialsResponse.data || {}
  const filialsIsLoading = filialsResponse.isLoading

  if (!hasFilial) {
    return null
  }

  return {
    isDisabled: hasCompany && (!company || !!companiesJobData?.isLoading),
    options: items,
    length,
    isLoading: filialsIsLoading,
    setPage: filialsResponse.setPage,
    setFilters: filialsResponse.setFilters,
  }
}

export default useFilialsJobData
